export default function FaultsViewEditAssetsDirective(
  $uibModal,
  $timeout,
  $stateParams,
  $filter,
  $rootScope,
  faultsService,
  equipmentRepository,
  gettextCatalog
) {
  'ngInject';

  return {
    template: require('./assets.html'),
    transclude: true,
    restrict: 'E',
    scope: {},
    controller: EditFaultAssetsController,
    controllerAs: 'vm',
    bindToController: {
      assets: '='
    }
  };

  function EditFaultAssetsController() {
    let vm = this;
    let configurationId = $stateParams.configurationId;
    const resetFlags = () => {
      vm.errorFlag = false;
      vm.successFlag = false;
      vm.removeLastAssetMsgFlag = false;
    };

    vm.assets = [];
    vm.animationsEnabled = true;
    vm.configurationName = '';
    vm.equipmentByPage = [];
    vm.equipments = []; //list of equipments to send to the database
    vm.errorFlag = false;
    vm.errorText = '';
    vm.loading = true;
    vm.onLoadErrorFlag = false;
    vm.onLoadErrorText = '';
    vm.postRemoval = [];
    vm.removeLastAssetMsgFlag = false;
    vm.removeLastAssetMsg = gettextCatalog.getString('You must have at least one Asset per Configuration.');
    vm.removals = [];
    vm.searchText = '';
    vm.successFlag = false;
    //Sorting
    vm.predicate = 'name';
    vm.reverse = false;
    //Pagination
    vm.pagination = {
      currentPage: 1,
      itemsPerPage: 15,
      maxSize: 1,
      startFrom: startFrom
    };

    //Local Functions
    vm.initializeEquipments = initializeEquipments;
    vm.orderEquipmentList = orderEquipmentList;
    vm.toggleAnimation = toggleAnimation;
    vm.saveEquipments = saveEquipments;
    vm.toggleRemoval = toggleRemoval;
    vm.applyChange = applyChange;
    vm.openModal = openModal;

    //Sort filteredEquipmentList
    function orderEquipmentList(predicate) {
      if (predicate === vm.predicate) {
        vm.reverse = !vm.reverse;
      } else {
        vm.reverse = false;
      }
      vm.predicate = predicate;
    }

    function initializeEquipments() {
      let existingIds = {
        criteria: {
          ids: []
        }
      };
      vm.equipments = vm.equipmentData;

      for (let i = 0; i < vm.equipments.length; i++) {
        existingIds.criteria.ids.push(vm.equipments[i]);
      }
      if (existingIds.criteria.ids.length > 0) {
        equipmentRepository.postEquipmentListByIds(existingIds).then(
          function(response) {
            vm.loading = false;
            vm.equipments = response.data;
            vm.postRemoval = vm.equipments.slice();
          },
          function(error) {
            let errorMsg = gettextCatalog.getString('Unable to retrieve Asset information');
            vm.loading = false;
            vm.onLoadErrorText = errorMsg;
            vm.onLoadErrorFlag = true;
          }
        );
      } else {
        vm.loading = false;
      }
    }

    function init() {
      getConfigurationEquipmentData();
    }
    init();

    function getConfigurationEquipmentData() {
      if (vm.assets && vm.assets.length > 0) {
        vm.loading = true;
        vm.equipmentData = [];
        for (let j = 0; j < vm.assets.length; j++) {
          vm.equipmentData.push(vm.assets[j].id);
        }
        vm.initializeEquipments();
      } else if (configurationId) {
        faultsService
          .getConfigById(configurationId)
          .then(function(response) {
            if (!response) {
              return;
            }
            vm.configurationName = response.name;
            vm.equipmentData = [];
            for (let j = 0; j < response.equipment.length; j++) {
              vm.equipmentData.push(response.equipment[j]);
            }
            initializeEquipments();
          })
          .catch(function(error) {
            let errorMsg = gettextCatalog.getString('An error occurred while retrieving configuration information.');
            vm.errorText = errorMsg;
            vm.errorFlag = true;
          })
          .finally(function() {
            vm.loading = false;
          });
      } else {
        vm.loading = false;
        vm.onLoadErrorFlag = true;
        vm.onLoadErrorText = gettextCatalog.getString('Could not load page: no configuration Id provided.');
      }
    }

    //Asset Picker - Add/Remove equipment to/from configuration
    function openModal(size) {
      let modalScope = $rootScope.$new();
      modalScope.modalTitle = 'Select Assets for Configuration: ' + vm.configurationName;
      resetFlags();
      let modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        template: require('../../../../../../components/assetpicker/asset.multi.picker.html'),
        controller: 'AssetMultiPickerController',
        size: 'lg',
        scope: modalScope,
        resolve: {
          singleSelect: false,
          requiresSelection: true,
          maxSelection: () => 0,
          selectedAssets: () => {
            let selected = {};

            if (vm.equipments) {
              for (let equipment of vm.equipments) selected[equipment.id] = equipment;
            }
            return selected;
          }
        }
      });

      modalInstance.result.then(handleModalAssets);
    }

    const handleModalAssets = modalAssets => {
      let changeSet = [];
      let resultEquipmentList = [];

      if (modalAssets.added && Array.isArray(modalAssets.added)) {
        modalAssets.added.forEach(added => changeSet.push({equipId: added, op: 'add'}));
      }

      if (modalAssets.removed && Array.isArray(modalAssets.removed)) {
        modalAssets.removed.forEach(removed => changeSet.push({equipId: removed, op: 'remove'}));
      }

      for (let assetId in modalAssets.result) resultEquipmentList.push(modalAssets.result[assetId]);

      vm.saveEquipments(resultEquipmentList, changeSet);
    };

    function toggleAnimation() {
      vm.animationsEnabled = !vm.animationsEnabled;
    }

    function saveEquipments(newEquipmentList, changeset) {
      if (changeset.length === 0 || vm.sending) {
        return;
      }
      if (newEquipmentList.length === 0 || vm.equipments.length === newEquipmentList.length) {
        vm.removeLastAssetMsgFlag = true;
        return;
      }
      vm.errorFlag = false;
      let data = {
        changeset: changeset
      };
      vm.sending = true;

      faultsService.patchFaultConfigEquipment(configurationId, data).then(
        function(response) {
          if (newEquipmentList) {
            vm.equipments = newEquipmentList.slice();
            vm.postRemoval = vm.equipments.slice();
          }
          orderEquipmentList(vm.predicate, false);
          vm.successFlag = true;
          vm.sending = false;
          $timeout(function() {
            resetFlags();
          }, 2500);
        },
        function(error) {
          let errorMsg = gettextCatalog.getString('An error occurred while editing Assets');
          vm.errorText = errorMsg;
          vm.errorFlag = true;
          vm.sending = false;
        }
      );
      return true;
    }

    function toggleRemoval(equip) {
      resetFlags();
      for (let i = 0; i < vm.postRemoval.length; i++) {
        if (vm.postRemoval[i].id === equip.id) {
          vm.postRemoval.splice(i, 1);
          applyChange(
            {
              op: 'remove',
              equipId: equip.id
            },
            vm.removals
          );
          return;
        }
      }
      //if we're toggling the checkbox off, put that equipment back into the post-removal list
      vm.postRemoval.push(equip);
      applyChange(
        {
          op: 'add',
          equipId: equip.id
        },
        vm.removals
      ); //will cancel out the 'remove' operation for that equip
    }

    function applyChange(newChange, changeset) {
      resetFlags();
      for (let i = 0; i < changeset.length; i++) {
        //handle behaviour when multiple changes requested for same resource
        if (changeset[i].equipId && changeset[i].equipId === newChange.equipId) {
          if (changeset[i].op === newChange.op) {
            //only apply one add or remove per resource
          } else {
            //if ops are different, changes will cancel out (ie. adding and removing a resource in the same request will have no net effect)
            changeset.splice(i, 1);
          }
          return;
        }
        changeset.push(newChange);
      }

      changeset.push(newChange);
    }

    function startFrom() {
      return (vm.pagination.currentPage - 1) * vm.pagination.itemsPerPage;
    }
  }
}
